import { RNTRC_AUTOCOMPLETE_URL } from '@/constants';
import { HttpStatusCode, fromRiskBff, httpClient } from '@/utils';
import { RntrcByPlateResponse } from './types';
import { UnauthorizedError } from '../errors';
import { RntrcByPlateModel } from '@/types';
import { valueOrEmptyString } from '@/utils/string';

const makeResult = (data: Partial<RntrcByPlateModel>): RntrcByPlateModel => ({
  name: valueOrEmptyString(data?.name),
  rntrc: valueOrEmptyString(data?.rntrc),
  document: valueOrEmptyString(data?.document),
  rntrcUuid: valueOrEmptyString(data?.rntrcUuid),
});

export const loadRntrcByPlateService = async (plate: string) => {
  const params = { plate };
  const { body, status } = await httpClient.get<RntrcByPlateResponse>(fromRiskBff(RNTRC_AUTOCOMPLETE_URL), { params });

  switch (status) {
    case HttpStatusCode.ok:
      return makeResult(body.data);

    case HttpStatusCode.unauthorized:
      throw new UnauthorizedError();

    default:
      return makeResult({});
  }
};
